import { createLazySubscriptionResolver } from 'owa-lazy-resolver';

export const lazySubscribeToUnreadCountNotificationsWeb = createLazySubscriptionResolver(
    () => import('./queries/subscribeToUnreadCountNotificationsWeb'),
    m => m.subscribeToUnreadCountNotificationsWeb
);
